<template>
<div :class="isHome">
    <card
        class="border-0 text-center h-100 w-100"
        :style="home ? { background: content.settings.card_color } : $bgColor(categoryColor || plan.layout.card_background || layout.default_card_background || color.primary)"
        header-classes="bg-transparent"
        footer-classes="bg-transparent"
        :body-classes="bodyClasses"
    >
        <template #header>
            <PlanHeader
                v-if="home && content.settings.show_title || !home"
                :plan="plan"
                :content="content"
            />
        </template>
        <template v-if="bodyInImageSlot" #image>
            <HomePlanBody v-if="home" :plan="plan" :content="content" />
            <ShowcasePlanBody v-else :plan="plan" :content="content" />
        </template>
        <template v-if="true">
            <HomePlanBody
                v-if="home && !bodyInImageSlot"
                :plan="plan"
                :content="content"
            />
            <ShowcasePlanBody
                v-else-if="!home && (plan.layout.upload || plan.layout.source) && !bodyInImageSlot"
                :plan="plan"
                :content="content"
            />
            <PlanPrice
                v-if="showPrice && hasBilling"
                :plan="plan"
                :content="content"
                :is-home="home"
            />
            <span
                v-if="showDescription && (home ? plan.info.plan_details : plan.info.showcase && !!plan.translation.extra_info)"
                class="extra-info"
                :style="{ color: home ? content.settings.card_text_color : ('var(--page-text-secondary, ' + color.secondary + ')') }"
            >
                {{plan.translation.extra_info}}
            </span>
            <span
                v-if="released"
                class="text-secondary"
            >
                {{ $t('dashboard.plan.release_date') }}
                <b>{{ $moment(released).format('DD/MM/YYYY') }}</b>
            </span>
        </template>
        <template #footer>
            <div class="d-flex flex-column align-items-center justify-content-between mt-3">
                <BaseButton
                    ref="button-primary"
                    @click="baseInput.event"
                    :loading="loading"
                    :disabled="!!salesLimit"
                    :style="home ? homePrimaryButtonStyle : primaryButtonDefaultStyle"
                    :type="!home ? 'success' : ''"
                    v-if="
                        home ?
                        (content.settings &&
                        content.settings.buttons &&
                        content.settings.buttons.primary.status) : true"
                >
                    {{ $t(baseInput.label) }}
                </BaseButton>
                <span
                    v-if="!!salesLimit"
                    :style="{ color: home ? color.secondary : ('var(--page-text-secondary, ' + color.secondary + ')') }"
                    class="mt-2"
                >
                    <i class="mdi mdi-information"/>
                    {{ $t(salesLimit) }}
                </span>
            </div>
            <BaseButton
                v-if="
                    home &&
                    content.settings &&
                    content.settings.buttons &&
                    content.settings.buttons.secondary.status
                "
                class="font-weight-bold mt-2"
                tag="a"
                :href="`/details/plan/${plan.translation.slug}`"
                :style="home ? homeSecondaryButtonStyle : secondaryButtonDefaultStyle"
                :type="!home ? 'info' : ''"
                >
                    {{ home ? content.settings.buttons.secondary.title : $t('common.details') }}
                </BaseButton>
            <a
                v-else-if="!home"
                class="btn font-weight-bold ma-2"
                :style="secondaryButtonDefaultStyle"
                :href="`/details/plan/${plan.translation.slug}`"
            >
                {{ $t('common.details') }}
            </a>
        </template>
    </card>
    <CouponModal
        v-model="couponModal"
        :plan="plan"
        :addCart="addCart"
        @goCart="goCart"
    />
    <CartAddRecurrence
        v-if="plan.recurrenceOption"
        v-model="addCartModal"
        :planId="plan.id"
        :recurrenceOption="plan.recurrenceOption.id"
    />
</div>
</template>

<script>
import BaseInput from '../../argon/components/Inputs/BaseInput';
import BaseButton from '../../argon/components/BaseButton';
import BaseDropdown from '../../argon/components/BaseDropdown';
import Card from '../../argon/components/Cards/Card';
import Modal from '../../argon/components/Modal';

import image from '../../mixins/image';
import CartAddRecurrence from '../CartComponents/CartAddRecurrence';
import PlanHeader from './PlanHeader';
import HomePlanBody from './HomePlanBody';
import ShowcasePlanBody from './ShowcasePlanBody';
import PlanPrice from './PlanPrice';
import CouponModal from './CouponModal';

export default {
    name: 'PlansInfo',

    mixins: [image],

    components: {
        Card,
        BaseButton,
        BaseDropdown,
        Modal,
        BaseInput,
        CartAddRecurrence,
        PlanHeader,
        HomePlanBody,
        ShowcasePlanBody,
        PlanPrice,
        CouponModal,
    },

    props: {
        content: Object,
        layout: Object,
        home: Boolean,
        color: {
            type: Object,
            required: true,
            description: 'Cores da plataforma',
        },
        plan: {
            type: Object,
            required: true,
        },
        categoryColor: {
            type: String,
            default: null,
        },
        showPrice: {
            type: Boolean,
            default: true,
        },
        showDescription: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            loading: false,
            couponModal: false,
            addCartModal: false,
            released: this.plan.release_date,
        };
    },
    computed: {
        bodyInImageSlot() {
            if (this.home) {
                return !!(this.content.settings.images && this.content.settings.images.type === 1);
            }
            if (this.plan.layout.upload || this.plan.layout.source) {
                return this.plan.layout.type === 1 && !this.plan.layout.position;
            }
            return false;
        },
        homePrimaryButtonStyle() {
            const { settings } = this.content;
            return {
                background: settings.buttons.primary.bg_color,
                color: settings.buttons.primary.color,
                'font-family': settings.buttons.primary.font_family,
            };
        },
        homeSecondaryButtonStyle() {
            const { settings } = this.content;
            return {
                background: settings.buttons.secondary.bg_color,
                color: settings.buttons.secondary.color,
                'font-family': settings.buttons.secondary.font_family,
            };
        },
        primaryButtonDefaultStyle() {
            return {
                background: this.layout.default_primary_background,
                borderColor: this.layout.default_primary_background,
                color: this.layout.default_primary_color,
            };
        },
        secondaryButtonDefaultStyle() {
            return {
                background: this.layout.default_secondary_background,
                borderColor: this.layout.default_secondary_background,
                color: this.layout.default_secondary_color,
            };
        },
        baseInput() {
            if (this.plan.type === 2) {
                return {
                    event: this.goPublicPlan,
                    label: this.setTextButtonPrimary('cart.access_plan'),
                };
            } else if (this.plan.type === 1) {
                return {
                    event: this.subscribe,
                    label: this.setTextButtonPrimary('cart.subscribe'),
                };
            } else if (this.plan.isCart) {
                return {
                    event: this.goCart,
                    label: 'cart.go_to_cart',
                };
            } else if (this.plan.type === 4) {
                return {
                    event: this.addPriceblePlan,
                    label: this.setTextButtonPrimary('common.buy'),
                };
            }
            return {
                event: this.addPriceblePlan,
                label: this.setTextButtonPrimary('cart.add_to_cart'),
            };
        },
        isHome() {
            if (!this.home) {
                return `col-lg-${12 / (this.layout.column_count)} col-md-6 col-sm-6 col-12 my-2`;
            }
            return null;
        },
        user() {
            return this.$store.getters.USER;
        },
        hasBilling() {
            return this.$getSettings.clientSettings && this.$getSettings.clientSettings.app && this.$getSettings.clientSettings.app.billing;
        },
        bodyClasses() {
            // flex-grow-1: o corpo absorve a folga do card (altura igualada pela
            // linha) e empurra o footer/botão pro fundo — assim os botões
            // "Inscreva-se" alinham entre planos de tipos diferentes.
            const classes = 'd-flex flex-column align-items-center py-0 flex-grow-1';
            if (this.plan.layout.type === 1 && !this.plan.layout.position) {
                return `${classes} justify-content-center`;
            }
            return `${classes} justify-content-around`;
        },
        salesLimit() {
            return this.plan.message;
        },
    },
    methods: {
        goPublicPlan() {
            this.$loading.show();
            // Verifica se o plano tem captura de leads ativa
            if (this.plan.link_leads) {
                // Redireciona para a página de captura de leads
                const leadsUrl = `/app/public/plan/${this.plan.id}/leads`;
                window.location.href = leadsUrl;
            } else {
                // Acesso direto ao plano - obter URL assinada
                window.axios.get(`/api/app/public/plan/${this.plan.id}/signed-url`)
                    .then((urlResponse) => {
                        if (urlResponse.data && urlResponse.data.url) {
                            window.location.href = urlResponse.data.url;
                        } else {
                            console.error('No signed URL returned');
                            window.location.href = `/app/public/plan/${this.plan.id}`;
                        }
                    })
                    .catch((error) => {
                        console.error('Error getting signed URL:', error);
                        window.location.href = `/app/public/plan/${this.plan.id}`;
                    });
            }
        },
        goCart() {
            this.$loading.show();
            window.location.href = '/cart';
        },
        subscribe() {
            if (!this.user.id || this.user.public) {
                localStorage.setItem('plan', this.plan.translation.name);
                localStorage.setItem('plan-id', this.plan.id);
                location.href = '/register';
            } else this.addCart(this.plan.id);
        },
        addPriceblePlan() {
            if (this.plan.has_coupon && !this.plan.isCart) {
                this.couponModal = true;
            } else {
                this.addCart(this.plan.id);
            }
        },
        async addCart(id, addCoupon = false) {
            this.loading = true;
            const body = {};
            const hasRecurrenceOption = this.plan.type === 4 && this.plan.recurrenceOption;
            if (hasRecurrenceOption) {
                body.recurrence_option = this.plan.recurrenceOption.id;
            }
            return window.axios
                .post(`api/cart/add/${id}`, body)
                .then(({ data }) => {
                    this.loading = false;
                    if (!addCoupon) {
                        if (this.plan.type === 3) {
                            this.$emit('isCart', id);
                        } else if (this.plan.type === 4) {
                            location.href = '/cart';
                        }
                        this.$store.commit('ADD_CART_ITEM');
                    }
                    this.$notify({
                        type: 'success',
                        message: this.$t(data.message),
                    });
                    if (!addCoupon) {
                        this.$emit('reload');
                    }
                })
                .catch(({ response }) => {
                    this.loading = false;
                    if (!addCoupon && response.data.code === 304) {
                        this.addCartModal = true;
                        return;
                    }
                    this.$notify({
                        type: 'danger',
                        message: this.$t(response.data.error),
                    });
                });
        },
        setTextButtonPrimary(textShowPlains) {
            return this.home
                ? this.content.settings.buttons.primary.title
                : textShowPlains;
        },
    },
};
</script>

<style scoped>
.nch--card-thumb {
    width: 100%;
}
.display-2{
    font-size: 2.4rem;
}
.nch--card-thumb:after {
    content: '';
    display: block;
    padding-bottom: 100%;
}

.zoom {
    transition: transform 0.3s;
}

.zoom:hover {
    transform: scale(1.03);
}

.iframe__box {
    box-shadow: 0 10px 25px 0 rgba(0, 0, 0, 0.3);
}
.card-header h4 {
    cursor: default;
    height: 74px;
    display: flex;
    align-items: center;
    justify-content: center;
}
.card-price {
    cursor: default;
}
.extra-info {
    width: 100%;
    word-wrap: break-word;
}
</style>
